import React from 'react';
import WranglerMarker from './wrangler-marker';

function WranglerMarkers({
  wranglers, onClick, onClose, selectedWranglerId,
}) {
  return (
    <>
      {wranglers.map((wrangler) => (
        <WranglerMarker
          key={wrangler._id}
          wrangler={wrangler}
          onClick={onClick}
          onClose={onClose}
          isSelected={selectedWranglerId === wrangler._id}
        />
      ))}
    </>
  );
}

export default WranglerMarkers;
